export const FM_STATUSES = {
  NO_FANNIE_MAE_REVIEW: "No Fannie Mae Review",
  UNAVAILABLE: "Unavailable",
  APPROVED_BY_FANNIE_MAE: "Approved By Fannie Mae",
  CONDITIONAL_APPROVAL: "Conditional Approval",
};
